module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0040_certificate_software_linked_devices")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "紐付機器一覧"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "25%",
      "float": "left",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": _vm.disableReturn
    },
    on: {
      "click": _vm.backToCertificateDetail
    }
  }, [_vm._v("＜　戻る")])])]), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "230px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-8"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "counter_label"
  }, [_vm._v("ライセンス数")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localTotalLicenses),
      expression: "localTotalLicenses"
    }],
    staticClass: "form-control counter_input ",
    attrs: {
      "readonly": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.localTotalLicenses)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localTotalLicenses = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "counter_label"
  }, [_vm._v("総使用数")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localEffectiveNumber),
      expression: "localEffectiveNumber"
    }],
    staticClass: "form-control counter_input ",
    attrs: {
      "readonly": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.localEffectiveNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localEffectiveNumber = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "counter_label"
  }, [_vm._v("残数")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localNumberOfRemaining),
      expression: "localNumberOfRemaining"
    }],
    class: {
      'form-control': true, counter_input: true, counter_input_error: _vm.localNumberOfRemaining < 0
    },
    attrs: {
      "readonly": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.localNumberOfRemaining)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localNumberOfRemaining = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "counter_label"
  }), _vm._v(" "), _c('td', [(_vm.localNumberOfRemaining < 0) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_c('br'), _vm._v("\n                    ※機器の使用数がライセンスの残数を上回っています。\n                    "), _c('br'), _vm._v("不要な機器を選択し「紐付解除」より紐付けを解除してください。\n                    ")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.localCertificateSeqId < 0
    },
    on: {
      "click": _vm.unlinkItem
    }
  }, [_vm._v("紐付解除")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.disableSelectNew
    },
    on: {
      "click": _vm.linkNewItem
    }
  }, [_vm._v("追加")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db1cbe40","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page_0040_certificate_software_linked_devices.vue
// module id = 1066
// module chunks = 0